module.exports = __webpack_public_path__ + "static/img/ios3.ede39776.jpg";